<template>
    <MainContent title="Detalle de la plantilla">
        <template #header>
            <h4 class="pb-2">Detalle de la plantilla</h4>
        </template>
        <template #content>
            <ContentOrLoading>
                <b-row v-if="!loading">
                    <b-col cols="12" md="6">
                        <h2 class="pb-2 pb-md-3">Datos de la plantilla</h2>
                        <p><strong>Nombre:</strong> {{ plantilla.name }}</p>
                        <p><strong>Estado:</strong> {{ plantilla.status }}</p>
                        <p><strong>Idioma:</strong> <img :src="getFlag(plantilla.language)" :alt="plantilla.language" class="flag-icon"/></p>
                        <p><strong>Categoría:</strong> {{ plantilla.category }}</p>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-2 mt-md-0">
                        <h2 class="pb-2 pb-md-3">Vista Previa</h2>
                        <VistaPreviaComponent :components="plantilla.components" />
                    </b-col>
                </b-row>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent.vue'
    import VistaPreviaComponent from '@/components/backend/plantillas-whatsapp/VistaPreviaComponent';

    export default {
        data() {
            return {
                loading: false,
                plantilla: null
            }
        },
        methods: {
            getPlantilla() {
                this.loading = true;

                const data = {
                    filters: {},
                    teatro_id: this.teatro_id,
                    plantilla_id: this.plantilla_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.plantillas-whatsapp.show'), data).then(res => {
                    this.plantilla = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            getFlag(language) {
                const flags = {
                    'es_ES': 'https://flagcdn.com/w40/es.png',
                    'en_US': 'https://flagcdn.com/w40/us.png',
                    'en': 'https://flagcdn.com/w40/gb.png',
                    'ca': 'https://flagcdn.com/w40/cat.png'
                };

                return flags[language];
            }
        },
        computed: {
            teatro_id() {
                return this.$store.getters.getTeatro.id;
            },
            plantilla_id() {
                return parseInt(this.$route.params.plantilla_id);
            }
        },
        created() {
            this.getPlantilla();
        },
        components: {
            MainContent, VistaPreviaComponent
        }
    }
</script>

<style scoped>
.flag-icon {
    width: 24px;
    height: 16px;
    margin-left: 5px;
}
</style>